import { useState } from 'react';

interface RunPsConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  runPsDontAsk: boolean;
  onToggleDontAsk: (checked: boolean) => void;
}

export function RunPsConfirmModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  runPsDontAsk, 
  onToggleDontAsk 
}: RunPsConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-navy-800 border border-navy-700 rounded-lg p-4 w-[320px]">
        <div className="text-sm text-gray-100 mb-3">Enviar seleção atual para edição no Photoshop?</div>
        <label className="flex items-center gap-2 text-xs text-gray-400 mb-3">
          <input
            type="checkbox"
            checked={runPsDontAsk}
            onChange={(e) => onToggleDontAsk(e.target.checked)}
          />
          Não perguntar novamente
        </label>
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-xs rounded border border-navy-600 text-gray-300 hover:bg-navy-700"
          >Não</button>
          <button
            onClick={onConfirm}
            className="px-3 py-1.5 text-xs rounded bg-blue-600 hover:bg-blue-500 text-white"
          >Sim</button>
        </div>
      </div>
    </div>
  );
}
